import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const BeginHerePreview = () => (
  <section data-testid="begin-here-section" className="border-t border-stone/60 bg-white/50">
    <div className="mx-auto max-w-6xl px-6 md:px-10 py-28 md:py-40">
      <div className="max-w-2xl">
        <Reveal>
          <p className="eyebrow mb-6">Begin Here</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1]" data-testid="begin-here-headline">
            A quiet place to begin.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-taupe">
            You don’t have to change everything. Start with what you need today.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-14 md:mt-20" data-testid="resource-list">
          <Link
            to="/begin-here"
            data-testid="begin-here-cta-button"
            className="inline-block bg-teal text-ivory text-xs uppercase tracking-[0.25em] px-10 py-4 hover:bg-deepteal transition-colors duration-500"
          >
            Find What You Need
          </Link>
          <p className="mt-8 text-sm leading-relaxed text-taupe/80 max-w-md">
            Free practices, guides and the opening of REGULATE — gathered
            quietly on the Begin Here page.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default BeginHerePreview;
